export default "__VITE_ASSET__Dfoy2wEf__"